import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProgressState } from '../reducers/progress.reducer';
import { PROGRESS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ProgressState>(PROGRESS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: ProgressState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ProgressState) => state.loading);
export const selectItems = createSelector(selectState, (state: ProgressState) => state.items);

// Lesson-specific selectors
export const selectLessonsCompleted = (courseId: string) =>
    createSelector(selectItems, (items) => items.filter((item) => item.courseId === courseId && item.itemType === 'lesson' && item.completed).length);

export const selectIsLessonCompleted = (id: string) =>
    createSelector(selectItems, (items) => {
        const lessons = items.filter((item) => item.lessonId === id);
        return lessons.length > 0 && lessons.every((item) => item.completed);
    });

// Quiz-specific selectors
export const selectQuizzesCompleted = (courseId: string) =>
    createSelector(selectItems, (items) => items.filter((item) => item.courseId === courseId && item.itemType === 'quiz' && item.completed).length);

export const selectIsQuizCompleted = (quizId: string) =>
    createSelector(selectItems, (items) => {
        const quizzes = items.filter((item) => item.quizId === quizId);
        return quizzes.length > 0 && quizzes.every((item) => item.completed);
    });

// Combined selectors (lessons + quizzes)
export const selectItemsCompleted = (courseId: string) =>
    createSelector(selectItems, (items) => items.filter((item) => item.courseId === courseId && item.completed).length);

export const selectModulesCompleted = (courseId: string) =>
    createSelector(selectItems, (items) => {
        const courseItems = items.filter((item) => item.courseId === courseId);
        const moduleIds = Array.from(new Set(courseItems.map((item) => item.moduleId)));
        const completedModuleIds = moduleIds.filter((moduleId) => courseItems.filter((item) => item.moduleId === moduleId).every((item) => item.completed));

        return completedModuleIds.length;
    });

export const selectCoursesCompleted = createSelector(selectItems, (items) => {
    const courseIds = Array.from(new Set(items.map((item) => item.courseId)));
    const completedCourseIds = courseIds.filter((courseId) => items.filter((item) => item.courseId === courseId).every((item) => item.completed));

    return completedCourseIds.length;
});

export const selectIsCourseCompleted = (courseId: string) =>
    createSelector(selectItems, (items) => {
        const courseItems = items.filter((item) => item.courseId === courseId);
        return courseItems.length > 0 && courseItems.every((item) => item.completed);
    });
